import { Reveal } from "../components/shared";
import { SiteLayout, PageHero, CtaBand, ReferBtn, Caps, H2 } from "../components/site";
import { CONTACT } from "../content";

export default function Professionals() {
  return (
    <SiteLayout testid="professionals-page">
      <PageHero eyebrow="For professionals & organisations" lines={["Partners in care.", "Support for professionals."]} sub="Clinical and professional supervision for practitioners, plus referral support for GPs.">
        <ReferBtn testid="pros-refer" />
        <a href={`${CONTACT.emailHref}?subject=${encodeURIComponent("Supervision enquiry")}`} data-testid="pros-email" className="inline-flex items-center rounded-full bg-[#3F4A3C] px-6 py-3.5 font-jakarta text-sm text-[#F6F2E9] hover:bg-[#5F7C8A] transition-colors">Enquire about supervision</a>
      </PageHero>
      <section id="supervision" className="scroll-mt-28 max-w-[1360px] mx-auto px-5 sm:px-10 pb-10" data-testid="pro-supervision">
        <Reveal className="rounded-[28px] bg-[#E3E9E4] p-8 sm:p-12 grid md:grid-cols-3 gap-8 items-center">
          <div className="flex -space-x-4">{["steven", "kate", "nicole"].map((id) => <img key={id} src={`/images/team/${id}.jpg`} alt="" className="w-20 h-20 rounded-full object-cover object-top border-4 border-[#E3E9E4]" />)}</div>
          <div className="md:col-span-2"><Caps>Supervision for practitioners</Caps><H2 className="mt-3 !text-3xl sm:!text-4xl">Clinical and professional supervision with experienced practitioners, including PASE-accredited supervision.</H2></div>
        </Reveal>
      </section>
      <CtaBand />
    </SiteLayout>
  );
}
